export default __webpack_public_path__ + "static/media/instagram.3d68c46c.svg";